var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOvLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_611_44",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 800,
    height: 800
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    rx: 200,
    fill: "url(#paint0_linear_611_44)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_611_44)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "url(#paint1_linear_611_44)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0252524,
    y1: 500,
    x2: 800.025,
    y2: 502.02,
    stroke: "black",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 491L0 99V491H243Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 491.512L800 99V492L553 491.512Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 718L272 511L524 511.499L397 718Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_611_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 108L391.844 728.065C394.144 732.051 399.89 732.07 402.217 728.101L766 107.5",
    stroke: "#D14343",
    strokeWidth: 50,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M799.5 1.83349L757.5 73.4998L799.5 97.9998V1.83349Z",
    fill: "#D14343",
    stroke: "#D14343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2L42.5 74L0.5 98V2Z",
    fill: "#D14343",
    stroke: "#D14343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_611_44",
    x: -10.1489,
    y: 73.2896,
    width: 820.359,
    height: 702.777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_611_44"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_611_44",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_611_44",
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_611_44",
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvLogo);
export default __webpack_public_path__ + "static/media/ovLogo.d645388196f50c44417907711943b8a8.svg";
export { ForwardRef as ReactComponent };